import { QuestionnaireSection } from "./QuestionnaireSection"

export class Questionnaire {
    sections: QuestionnaireSection[]
}
